import { render, staticRenderFns } from "./numbergame.vue?vue&type=template&id=acfa5852&"
import script from "./numbergame.vue?vue&type=script&lang=js&"
export * from "./numbergame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports